import * as React from "react"

const ThreePL = props => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 317.44 297.71"
    {...props}
  >
    <title>{"3PL-ICON-2"}</title>
    <path
      d="M29.5 74.73a10.43 10.43 0 1 0-10.4 10.43 10.43 10.43 0 0 0 10.4-10.43Zm-18.4 0a8 8 0 1 1 8 8 8 8 0 0 1-8-8ZM298.37 85.16a10.43 10.43 0 1 0-10.43-10.43 10.44 10.44 0 0 0 10.43 10.43Zm0-18.39a8 8 0 1 1-8 8 8 8 0 0 1 8-8Z"
      fill="#007f6e"
    />
    <path
      d="M281.3 83a19 19 0 1 0 0-16.44H36.1a19 19 0 1 0 0 16.44Zm17.07-22.7a14.48 14.48 0 1 1-14.48 14.48 14.48 14.48 0 0 1 14.48-14.53ZM4.59 74.73A14.48 14.48 0 1 1 19.1 89.21 14.48 14.48 0 0 1 4.59 74.73Z"
      fill="#007f6e"
    />
    <path
      fill="#00b08e"
      d="m223.11 108.94-47.23-27.27V27.14l47.23 27.27v54.53z"
    />
    <path
      fill="#007f6e"
      d="M270.34 27.14v54.53l-47.23 27.27V54.41l47.23-27.27z"
    />
    <path
      fill="#b1da00"
      d="M270.34 27.2 223.11 0l-47.23 27.2 47.23 27.21 47.23-27.21z"
    />
    <path
      d="M29.5 169.12a10.43 10.43 0 1 0-10.4 10.43 10.43 10.43 0 0 0 10.4-10.43Zm-18.4 0a8 8 0 1 1 8 8 8 8 0 0 1-8-8ZM298.37 179.55a10.44 10.44 0 1 0-10.43-10.45 10.44 10.44 0 0 0 10.43 10.45Zm0-18.4a8 8 0 1 1-8 8 8 8 0 0 1 8-8Z"
      fill="#007f6e"
    />
    <path
      d="M281.3 177.34a19 19 0 1 0 0-16.45H36.1a19 19 0 1 0 0 16.45Zm17.07-22.7a14.48 14.48 0 1 1-14.48 14.48 14.48 14.48 0 0 1 14.48-14.48ZM4.59 169.12A14.48 14.48 0 1 1 19.1 183.6a14.5 14.5 0 0 1-14.51-14.48Z"
      fill="#007f6e"
    />
    <path
      fill="#00b08e"
      d="M121.23 203.32 74 176.06v-54.53l47.23 27.26v54.53z"
    />
    <path
      fill="#007f6e"
      d="M168.45 121.53v54.53l-47.23 27.26v-54.53l47.23-27.26z"
    />
    <path
      fill="#b1da00"
      d="m168.45 121.59-47.23-27.2L74 121.59l47.22 27.2 47.23-27.2z"
    />
    <path
      d="M29.5 263.5a10.43 10.43 0 1 0-10.4 10.44 10.43 10.43 0 0 0 10.4-10.44Zm-18.4 0a8 8 0 1 1 8 8 8 8 0 0 1-8-8ZM298.37 273.94a10.44 10.44 0 1 0-10.43-10.45 10.45 10.45 0 0 0 10.43 10.45Zm0-18.4a8 8 0 1 1-8 8 8 8 0 0 1 8-8Z"
      fill="#007f6e"
    />
    <path
      d="M281.3 271.73a19 19 0 1 0 0-16.45H36.1a19 19 0 1 0 0 16.45ZM298.37 249a14.48 14.48 0 1 1-14.48 14.48A14.48 14.48 0 0 1 298.37 249ZM4.59 263.5A14.48 14.48 0 1 1 19.1 278a14.48 14.48 0 0 1-14.51-14.5Z"
      fill="#007f6e"
    />
    <path
      fill="#00b08e"
      d="m197.64 297.71-47.23-27.27v-54.53l47.23 27.27v54.53z"
    />
    <path
      fill="#007f6e"
      d="M244.87 215.91v54.53l-47.23 27.27v-54.53l47.23-27.27z"
    />
    <path
      fill="#b1da00"
      d="m244.87 215.97-47.23-27.2-47.23 27.2 47.23 27.21 47.23-27.21z"
    />
  </svg>
)

export default ThreePL
